import React, { FC, useEffect, useState } from "react";
import { Row, Col, Collapse, Spin } from "antd";
import MemberItems from "@pages/member-details/items";

import PinUnpin from "@pages/member-details/pin-unpin-component";
import { centricClientCheck, formatDisplayDate, formatPhoneNumber } from "@utils/helpers";
import { cloneDeep } from "lodash";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";
const { Panel } = Collapse;


const GeneralDetail: FC<any> = (props) => {
  const dataCardId = "32";
  const isCentric = centricClientCheck();
  const [activeCardPanel, setActiveCardPanel] = useState<any>(props?.activeKey?.includes(dataCardId) ? ["1"] : [])

  useEffect(()=> {
    setActiveCardPanel(props?.activeKey?.includes(dataCardId) ? ["1"] : []);
  }, [props?.activeKey])

  const onCollapseChange = () => {
    if(activeCardPanel.length > 0){
      props?.setActivePanels(cloneDeep(props?.activeKey)?.filter((item:any) => item !== dataCardId))
    }
    else props?.setActivePanels([...(props?.activeKey ? props?.activeKey : []), dataCardId]);
  }

  const genExtra = (id:any) => <PinUnpin marginRight={"16px"} dataCardId={id} changeHandler={props?.pinChangeHandler}
  pinCardIds={props.pinCardIds}/>
  return (
    <>
      {/* <Card> */}
      <Collapse accordion defaultActiveKey={1} expandIconPosition="right" bordered={false} activeKey={activeCardPanel} onChange={onCollapseChange}>
        <Panel className="title" header={isCentric ? "Contact Details of Member" : "Contact Details"} key="1" extra={genExtra(dataCardId)} style={{ marginBottom: "8px" }}>
          <Spin spinning={props.loading} indicator={<HealthemSpinner size={50} />}>
            <Row gutter={48}>
              <Col span={12} style={{ paddingLeft: 0, paddingRight: 0 }}>
                <Col className="title" span={24} style={{ marginBottom: 16 }}>
                  <span>General</span>
                </Col>
                <Col span={24}>
                  <MemberItems left={12} right={12} name="Date of Birth" value={props?.data?.patientDOB && formatDisplayDate(props?.data?.patientDOB, "LastGapClosedFormat")} />
                </Col>
                <Col span={24}>
                  <MemberItems left={12} right={12} name="Phone Number" value={formatPhoneNumber(props?.data?.patientMobile, "usFormat")} />
                </Col>
                <Col span={24}>
                  <MemberItems left={12} right={12} name="Alt. Phone Number" value={formatPhoneNumber(props?.data?.patientAlternatePhoneNum, "usFormat")} />
                </Col>
                <Col span={24}>
                  <MemberItems
                    left={12}
                    right={12}
                    name="Email Address"
                    value={
                      props?.data?.patientEmail !== "--" ? (
                        <a className="mail-to-link" href={`mailto:${props?.data?.patientEmail}`}>
                          {props?.data?.patientEmail}
                        </a>
                      ) : (
                        props?.data?.patientEmail
                      )
                    }
                  />
                </Col>
              </Col>
              <Col span={12}>
                <Col className="title" span={24} style={{ marginBottom: 16 }}>
                  <span>Address</span>
                </Col>

                <Col span={24}>
                  <MemberItems left={12} right={12} name="Street" value={props?.data?.patientStreet} />
                </Col>
                <Col span={24}>
                  <MemberItems left={12} right={12} name="City" value={props?.data?.patientCity} />
                </Col>
                <Col span={24}>
                  <MemberItems left={12} right={12} name="State / Province" value={props?.data?.patientState} />
                </Col>
                <Col span={24}>
                  <MemberItems left={12} right={12} name="Zip Code / Postal Code" value={props?.data?.patientZipCode} />
                </Col>
              </Col>
            </Row>
          </Spin>
        </Panel>
      </Collapse>
      {/* </Card> */}
    </>
  );
};

export default GeneralDetail;
